<script>
import useSharedData from "@/use/SharedData";
import useTools from "@/use/Tools";
import {onMounted, ref} from "vue";
import StrCatalogAutocomplete from "@/views/Training/Catalog/Components/StrCatalogAutocomplete.vue";
import useValidation from "@/use/Validation";
import useSharedMethod from "@/use/SharedMethod";
import {useTrainingRequestStore} from "@/stores/Training/TrainingRequest";
import axios from "axios";

export default {
    name: "ValidateOtherCatalog",
    components: {StrCatalogAutocomplete},
    setup() {
        const {dialog, loading} = useSharedData();
        const {$route} = useTools();
        const {mxRules} = useValidation();
        const {getBack} = useSharedMethod();

        const trainingRequestStore = useTrainingRequestStore();

        const trainingRequest = ref({});
        const catalogId = ref(null);

        function findById() {
            loading.value = true;
            axios.get(`/trainingRequests/${$route.params.id}`).then(response => {
                trainingRequest.value = response.data;
            }).finally(() => {
                loading.value = false;
            });
        }

        function save() {
            loading.value = true;
            axios.put(`/trainingRequests/addToCatalog/${$route.params.id}`, catalogId.value).then(response => {
                trainingRequestStore.updateTrainingRequest(response.data);
                getBack();
            }).finally(() => {
                loading.value = false;
            });
        }

        onMounted(() => findById());

        return {
            mxRules,
            loading,
            dialog,
            trainingRequest,
            catalogId,
            getBack,
            save
        }
    }
}
</script>

<template>
    <div>
        <v-dialog
            v-model="dialog"
            persistent
            max-width="500"
        >
            <v-card>
                <w-toolbar color="teal" :title="`${$t('training.add_to_catalog')} (${trainingRequest.otherDescription})`" />
                <v-card-text>
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="11">
                                <w-label :label="$t('training.theme')" required/>
                                <str-catalog-autocomplete
                                    v-model="catalogId"
                                    :rules="[mxRules.required]"
                                />
                            </v-col>
                            <v-col cols="1">
                                <w-btn-icon
                                    color="teal"
                                    icon="mdi-plus-circle-outline"
                                    @press="$router.push({name: 'training_plan_details.add_to_catalog.catalogs.add'})"
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <w-btn-close @press="getBack"/>
                    <w-btn-add
                        show
                        :loading="loading"
                        @press="save"
                    />
                </v-card-actions>
            </v-card>
        </v-dialog>
        <router-view/>
    </div>
</template>